import { render, staticRenderFns } from "./DocumentsFilter.vue?vue&type=template&id=48fe1d27&"
import script from "./DocumentsFilter.vue?vue&type=script&lang=js&"
export * from "./DocumentsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports